module.exports = __webpack_public_path__ + "static/media/sign-in-bg.7d3e830a.png";